(() => {
  const roots = document.querySelectorAll('.k9-ovenbaked-lp:not([data-k9-ovenbaked-ready])');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class K9LpSlider {
    constructor(root, { loop = false } = {}) {
      this.root = root;
      this.track = root.querySelector('.swiper-wrapper');
      this.slides = [...root.querySelectorAll('.swiper-slide')];
      this.previous = root.querySelector('[class*="slider-button--prev"]');
      this.next = root.querySelector('[class*="slider-button--next"]');
      this.pagination = root.querySelector('[class*="slider-pagination"]');
      this.loop = loop;
      this.index = 0;

      if (!this.track || this.slides.length < 2) return;

      this.previous?.setAttribute('role', 'button');
      this.previous?.setAttribute('tabindex', '0');
      this.previous?.setAttribute('aria-label', '前のスライド');
      this.next?.setAttribute('role', 'button');
      this.next?.setAttribute('tabindex', '0');
      this.next?.setAttribute('aria-label', '次のスライド');

      this.previous?.addEventListener('click', () => this.move(-1));
      this.next?.addEventListener('click', () => this.move(1));
      this.previous?.addEventListener('keydown', (event) => this.onKeydown(event, -1));
      this.next?.addEventListener('keydown', (event) => this.onKeydown(event, 1));
      this.buildPagination();
      this.mediaQuery = window.matchMedia('(max-width: 767px)');
      this.mediaQuery.addEventListener('change', () => this.render());
      this.render();
    }

    onKeydown(event, direction) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.move(direction);
    }

    buildPagination() {
      if (!this.pagination) return;

      this.pagination.replaceChildren();
      this.slides.forEach((_, index) => {
        const bullet = document.createElement('button');
        bullet.type = 'button';
        bullet.className = 'swiper-pagination-bullet';
        bullet.setAttribute('aria-label', `スライド${index + 1}を表示`);
        bullet.addEventListener('click', () => {
          this.index = index;
          this.render();
        });
        this.pagination.append(bullet);
      });
    }

    move(direction) {
      if (!this.mediaQuery.matches) return;

      const nextIndex = this.index + direction;
      if (this.loop) {
        this.index = (nextIndex + this.slides.length) % this.slides.length;
      } else {
        this.index = Math.min(Math.max(nextIndex, 0), this.slides.length - 1);
      }
      this.render();
    }

    render() {
      const isMobile = this.mediaQuery.matches;
      this.track.style.transition = isMobile && !prefersReducedMotion.matches ? 'transform 500ms ease' : '';
      this.track.style.transform = isMobile ? `translate3d(-${this.index * 100}%, 0, 0)` : '';

      this.slides.forEach((slide, index) => {
        slide.style.flex = isMobile ? '0 0 100%' : '';
        slide.setAttribute('aria-hidden', isMobile && index !== this.index ? 'true' : 'false');
      });

      [...(this.pagination?.children || [])].forEach((bullet, index) => {
        bullet.classList.toggle('swiper-pagination-bullet-active', index === this.index);
        bullet.setAttribute('aria-current', index === this.index ? 'true' : 'false');
      });

      if (!this.loop) {
        this.previous?.classList.toggle('swiper-button-disabled', this.index === 0);
        this.next?.classList.toggle('swiper-button-disabled', this.index === this.slides.length - 1);
      }
    }
  }

  const setText = (root, selector, value) => {
    const element = root.querySelector(selector);
    if (element) element.textContent = value;
  };

  roots.forEach((root) => {
    root.dataset.k9OvenbakedReady = 'true';

    const viewport = document.querySelector('meta[name="viewport"]');
    const updateViewport = () => {
      if (!viewport) return;
      const value = window.outerWidth > 415 ? 'width=device-width,initial-scale=1' : 'width=375';
      if (viewport.getAttribute('content') !== value) viewport.setAttribute('content', value);
    };
    updateViewport();
    window.addEventListener('resize', updateViewport, { passive: true });

    const floatCta = root.querySelector('.js-float-cta');
    const updateFloatCta = () => floatCta?.classList.toggle('is-show', window.scrollY > 200);
    updateFloatCta();
    window.addEventListener('scroll', updateFloatCta, { passive: true });

    new K9LpSlider(root.querySelector('.recommendMixSlider'), { loop: true });
    new K9LpSlider(root.querySelector('.coldpressStepSlider'));

    root.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: prefersReducedMotion.matches ? 'auto' : 'smooth' });
      });
    });

    root.querySelectorAll('.js-faq-item').forEach((details) => {
      const summary = details.querySelector('.js-faq-summary');
      const content = details.querySelector('.js-faq-answer');
      if (!summary || !content) return;

      let isAnimating = false;
      summary.addEventListener('click', (event) => {
        if (prefersReducedMotion.matches || !content.animate) {
          details.classList.toggle('is-open', !details.open);
          return;
        }

        event.preventDefault();
        if (isAnimating) return;
        isAnimating = true;

        if (details.open) {
          details.classList.remove('is-open');
          const animation = content.animate(
            [{ height: `${content.scrollHeight}px`, opacity: 1 }, { height: 0, opacity: 0 }],
            { duration: 300, easing: 'ease-out' }
          );
          animation.onfinish = () => {
            details.open = false;
            isAnimating = false;
          };
        } else {
          details.open = true;
          details.classList.add('is-open');
          const animation = content.animate(
            [{ height: 0, opacity: 0 }, { height: `${content.scrollHeight}px`, opacity: 1 }],
            { duration: 300, easing: 'ease-out' }
          );
          animation.onfinish = () => {
            isAnimating = false;
          };
        }
      });
    });

    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('on');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -200px 0px' }
    );
    root.querySelectorAll('.fadeup, .toleft, .toright').forEach((element) => revealObserver.observe(element));

    const pinnedObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle(
            'is-active',
            entry.isIntersecting && entry.boundingClientRect.top <= 0
          );
        });
      },
      { rootMargin: '0px 0px -100% 0px', threshold: 0 }
    );
    root.querySelectorAll('.p-message-wrapper, .p-think-wrapper').forEach((element) => {
      pinnedObserver.observe(element);
    });

    const introWrapper = root.querySelector('.js-intro-wrapper');
    const introTexts = [...root.querySelectorAll('.p-intro__text')];
    const introImages = [...root.querySelectorAll('.p-intro__image')];
    const introKv = root.querySelector('.p-intro__kv');
    let introFrame;

    const updateIntro = () => {
      introFrame = undefined;
      if (!introWrapper) return;

      const scrollY = -introWrapper.getBoundingClientRect().top;
      const step = Math.min(Math.max(Math.floor(scrollY / 600), 0), 5);

      introTexts.forEach((text) => {
        const textStep = text.classList.contains('js-intro-start')
          ? 0
          : text.classList.contains('js-intro-01')
            ? 1
            : text.classList.contains('js-intro-02')
              ? 2
              : text.classList.contains('js-intro-03')
                ? 3
                : text.classList.contains('js-intro-04')
                  ? 4
                  : -1;
        text.classList.toggle('is-active', textStep === step);
      });

      introImages.forEach((image) => {
        const imageStep = image.classList.contains('js-intro-01')
          ? 1
          : image.classList.contains('js-intro-02')
            ? 2
            : image.classList.contains('js-intro-03')
              ? 3
              : 999;
        image.classList.toggle('is-active', step < 4 && step >= imageStep);
        image.classList.toggle('is-hidden', step >= 4);
      });
      introKv?.classList.toggle('is-active', step === 5);
    };

    if (introWrapper) {
      updateIntro();
      window.addEventListener(
        'scroll',
        () => {
          if (!introFrame) introFrame = requestAnimationFrame(updateIntro);
        },
        { passive: true }
      );
    }

    const select = root.querySelector('.js-feeding-select');
    const calculateButton = root.querySelector('.js-feeding-button');
    const resultContainer = root.querySelector('.js-feeding-result');
    const feedingData = {
      2: 50, 3: 69, 4: 84, 5: 95, 6: 114, 7: 126, 8: 136, 9: 153, 10: 160,
      11: 176, 12: 192, 13: 208, 14: 210, 15: 225, 16: 240, 17: 255, 18: 252,
      19: 266, 20: 280, 21: 294
    };

    calculateButton?.addEventListener('click', () => {
      if (!select?.value) {
        select?.reportValidity();
        return;
      }

      const weight = Number.parseInt(select.value, 10);
      const ovenbaked10 = weight <= 5 ? weight * 18 : weight <= 10 ? weight * 14 : weight * 12;
      const ovenbaked30 = weight <= 5 ? weight * 14 : weight <= 10 ? weight * 11 : weight * 9;
      const freezedry30 = weight <= 5 ? weight * 3 : weight * 2;
      const ovenbaked50 = weight <= 5 ? weight * 10 : weight <= 10 ? weight * 8 : weight * 7;
      const freezedry50 = weight <= 5 ? weight * 5 : weight * 4;

      setText(root, '.js-result-value', feedingData[weight]);
      setText(root, '.js-result-ovenbaked-10', ovenbaked10);
      setText(root, '.js-result-freezedry-10', weight);
      setText(root, '.js-result-ovenbaked-30', ovenbaked30);
      setText(root, '.js-result-freezedry-30', freezedry30);
      setText(root, '.js-result-ovenbaked-50', ovenbaked50);
      setText(root, '.js-result-freezedry-50', freezedry50);
      resultContainer?.classList.add('is-show');
    });
  });
})();
